// extracted by mini-css-extract-plugin
module.exports = {"FooterBottom":"FooterBottom_FooterBottom__FKOMv","FooterBottom__address":"FooterBottom_FooterBottom__address__Jv_7v"};